/* Just Silver - Shop by price "display stand" (08 CONCEPT).

   Each price band has a hairline drawing (snippets/jsq-stand-art.liquid) in the
   style of the collection banners, and the parts tagged data-fx move with the
   same engine as assets/jsq-banner-fx.js (kept identical in both files):

     pop      grows and lifts toward the cursor or finger (pearl, stones, links)
     sway     hangs from a pivot and swings when you pass (earrings)
     tilt     leans gently toward the pointer (the ring)
     twinkle  sparkles that breathe, and flare near the pointer

   Moving across the stand leaves a short trail of wine and ink sparkles, and
   one invisible sweep crosses the whole stand when it first comes into view.

   Phones (20 Oct 2026): scrolling sweeps each drawing as it crosses the
   screen, a touch reaches further and lingers, a tap plays one clear moment,
   a quiet sweep repeats every few seconds, and on Android the pieces lean
   with the phone's tilt (not on iOS, which would ask permission first).
   Touch listeners are passive, so the page always scrolls normally.

   Off for prefers-reduced-motion (the drawings simply stay still). Paused when
   the stand is off screen or the tab is hidden.

   Also fills in each band's piece count: it asks the band's own link for
   sections/jsq-count.liquid, so the number always matches the page it opens. */
(function () {
  'use strict';

  var d = document;
  var w = window;
  var RM = w.matchMedia('(prefers-reduced-motion: reduce)');
  var PHONE = w.matchMedia('(max-width: 47.99em)');
  var WIDE = w.matchMedia('(min-width: 48em)');
  var NS = 'http://www.w3.org/2000/svg';

  var num = function (v, dflt) { var n = parseFloat(v); return isNaN(n) ? dflt : n; };
  var clamp = function (v, a, b) { return v < a ? a : v > b ? b : v; };
  var fall = function (u) { return u >= 1 ? 0 : 1 - u * u * (3 - 2 * u); };
  var r3 = function (v) { return Math.round(v * 1000) / 1000; };
  var r2 = function (v) { return Math.round(v * 100) / 100; };
  var r1 = function (v) { return Math.round(v * 10) / 10; };

  /* ------------------------------------------------------- phone senses --- */

  // One scroll clock, one tilt reading and one frame loop, shared by every
  // engine on the page. A single loop keeps a phone's frames even; four loops
  // fighting for the same frame is what makes motion stutter.
  var SENSE = { scrollAt: 0, scrollY: w.scrollY || 0, scrollV: 0, tilt: null, engines: [], active: [], running: false, prev: 0, lite: false, slow: 0, fast: 0 };

  w.addEventListener('scroll', function () {
    var now = performance.now();
    var y = w.scrollY || 0;
    var dt = Math.max((now - SENSE.scrollAt) / 1000, 1 / 240);
    if (SENSE.scrollAt) SENSE.scrollV = SENSE.scrollV * .4 + ((y - SENSE.scrollY) / dt) * .6;
    SENSE.scrollY = y;
    SENSE.scrollAt = now;
    for (var i = 0; i < SENSE.engines.length; i++) SENSE.engines[i].wake();
  }, { passive: true });

  w.addEventListener('resize', function () {
    for (var i = 0; i < SENSE.engines.length; i++) SENSE.engines[i].geomAt = 0;
  }, { passive: true });

  // Tilt: Android only. iOS asks the shopper's permission before it will share
  // the sensor, and that prompt is not worth it; Safari exposes the request
  // function, so its presence is the test.
  var ua = navigator.userAgent || '';
  var TILT_OK = /Android/i.test(ua) && !/iPhone|iPad|iPod/i.test(ua) &&
    'DeviceOrientationEvent' in w && typeof w.DeviceOrientationEvent.requestPermission !== 'function';
  var tiltBound = false;
  var bindTilt = function () {
    if (tiltBound || !TILT_OK) return;
    tiltBound = true;
    var base = null, last = 0;
    var reading = { x: 0, y: 0, at: 0 };
    w.addEventListener('deviceorientation', function (e) {
      if (e.gamma == null || e.beta == null) return;
      var now = performance.now();
      if (now - last < 40) return;   // the sensor reports faster than the screen can use
      last = now;
      var g = e.gamma, b = e.beta;
      if (!base) { base = { g: g, b: b }; return; }
      // the resting position follows the hand slowly, so a steady hold relaxes
      base.g += (g - base.g) * .03;
      base.b += (b - base.b) * .03;
      reading.x = clamp((g - base.g) / 18, -1, 1);
      reading.y = clamp((b - base.b) / 18, -1, 1);
      reading.at = now;
      SENSE.tilt = reading;
      if (Math.abs(reading.x) + Math.abs(reading.y) > .1) for (var i = 0; i < SENSE.engines.length; i++) SENSE.engines[i].wake();
    }, { passive: true });
  };

  // The shared frame loop. On a phone that cannot hold 60 frames a second it
  // settles into an even 30, which looks smoother than an uneven 45.
  SENSE.loop = function () {
    if (SENSE.running) return;
    SENSE.running = true;
    SENSE.prev = performance.now();
    var skip = false;
    requestAnimationFrame(function tick(now) {
      var list = SENSE.active;
      if (!list.length || d.hidden) {
        for (var j = 0; j < list.length; j++) list[j].running = false;
        list.length = 0;
        SENSE.running = false;
        return;
      }
      var gap = now - SENSE.prev;
      if (PHONE.matches) {
        if (gap > 22) { SENSE.slow++; SENSE.fast = 0; } else { SENSE.fast++; }
        if (!SENSE.lite && SENSE.slow > 12) SENSE.lite = true;
        if (SENSE.lite && SENSE.fast > 240) { SENSE.lite = false; SENSE.slow = 0; }
        if (SENSE.lite && gap < 26) { skip = !skip; if (skip) { requestAnimationFrame(tick); return; } }
      }
      var dt = clamp(gap / 1000, 0, 1 / 15);
      SENSE.prev = now;
      for (var i = list.length - 1; i >= 0; i--) {
        var en = list[i];
        if (en.dead || !en.visible) { en.running = false; list.splice(i, 1); continue; }
        en.frame(now, dt);
      }
      requestAnimationFrame(tick);
    });
  };

  /* ------------------------------------------------------------ engine --- */

  function Engine(svg, hero, media) {
    this.svg = svg;
    this.hero = hero;
    this.media = media;
    this.root = svg.querySelector('[data-jx-root]');
    this.parts = [];
    this.sparks = [];
    this.pool = [];
    this.colors = (this.root.getAttribute('data-sparkle') || '#6E1F2A,#23252A').split(',');
    this.sweep = (this.root.getAttribute('data-sweep') || '-560 1120 -40 120').split(' ').map(Number);
    this.P = null;        // pointer in root units
    this.V = { x: 0, y: 0 };
    this.A = 0;           // how "present" the pointer is, 0..1
    this.want = 0;
    this.decay = 3;       // how quickly presence fades once the pointer has gone
    this.reach = 1;       // multiplies every part's reach (a finger reaches further)
    this.lastMove = 0;
    this.lastSpark = 0;
    this.ghost = null;
    this.nextGhost = 0;
    this.touching = false;
    this.touchAt = 0;
    this.touch0 = null;
    this.touchMoved = 0;
    this.holdUntil = 0;
    this.driver = '';     // what moves the pointer right now: touch, scroll, tilt, ghost
    this.geomAt = 0;
    this.running = false;
    this.visible = false;
    this.t0 = performance.now();
    this.collect();
    this.bind();
  }

  Engine.prototype.phone = function () { return PHONE.matches; };

  Engine.prototype.collect = function () {
    var root = this.root;
    var rootInv = root.getCTM().inverse();
    var els = root.querySelectorAll('[data-fx]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var ds = el.dataset;
      var pm = el.parentNode.getCTM();
      // parent frame -> root frame, then invert: root -> parent frame
      var toRoot = rootInv.multiply(pm);
      var inv = toRoot.inverse();
      var kinds = ds.fx.split(' ');
      var x = num(ds.x, 0), y = num(ds.y, 0);
      var p = {
        el: el,
        k: {},
        x: x, y: y,
        px: num(ds.px, x), py: num(ds.py, y),
        r: num(ds.r, 160),
        pop: num(ds.pop, .3),
        amp: num(ds.amp, 0),
        side: num(ds.side, 1),
        speed: num(ds.speed, 0),
        inv: inv,
        ph: Math.random() * Math.PI * 2,
        s: 1, vs: 0, dx: 0, dy: 0, vdx: 0, vdy: 0, a: 0, va: 0, spin: 0, omega: 0,
        last: ''
      };
      for (var j = 0; j < kinds.length; j++) p.k[kinds[j]] = true;
      this.parts.push(p);
    }
  };

  // Where the drawing is on screen and how screen pixels map to root units,
  // read from the browser at most twice a second and shifted by the scroll
  // in between: a layout read on every frame is what a budget phone cannot afford.
  Engine.prototype.geom = function () {
    var now = performance.now();
    var sy = w.scrollY || 0, sx = w.scrollX || 0;
    if (!this.geomAt || now - this.geomAt > 500) {
      var m = this.root.getScreenCTM();
      if (!m) return null;
      this.m = { a: m.a, b: m.b, c: m.c, d: m.d, e: m.e, f: m.f };
      var r = this.svg.getBoundingClientRect();
      this.rect = { left: r.left, top: r.top, width: r.width, height: r.height };
      this.geomScroll = { x: sx, y: sy };
      this.geomAt = now;
    }
    var ddx = sx - this.geomScroll.x, ddy = sy - this.geomScroll.y;
    return {
      m: { a: this.m.a, b: this.m.b, c: this.m.c, d: this.m.d, e: this.m.e - ddx, f: this.m.f - ddy },
      rect: { left: this.rect.left - ddx, top: this.rect.top - ddy, width: this.rect.width, height: this.rect.height }
    };
  };

  Engine.prototype.toRoot = function (cx, cy) {
    var g = this.geom();
    if (!g) return null;
    var m = g.m;
    var det = m.a * m.d - m.b * m.c;
    if (!det) return null;
    var x = cx - m.e, y = cy - m.f;
    return { x: (m.d * x - m.c * y) / det, y: (m.a * y - m.b * x) / det };
  };

  Engine.prototype.point = function (cx, cy, driver) {
    var p = this.toRoot(cx, cy);
    if (!p) return;
    var now = performance.now();
    if (this.P && this.lastMove && now - this.lastMove < 400) {
      var dt = Math.max((now - this.lastMove) / 1000, 1 / 240);
      var vx = (p.x - this.P.x) / dt, vy = (p.y - this.P.y) / dt;
      this.V.x = this.V.x * .5 + vx * .5;
      this.V.y = this.V.y * .5 + vy * .5;
    }
    this.P = p;
    this.lastMove = now;
    this.want = 1;
    this.driver = driver || 'pointer';
    if (this.driver !== 'ghost') this.ghost = null;
    this.wake();
  };

  Engine.prototype.release = function (slow) {
    this.want = 0;
    this.decay = slow ? 1.1 : 3;
    this.driver = '';
    this.wake();
  };

  Engine.prototype.bind = function () {
    var self = this;
    var hero = this.hero;
    this.onMove = function (e) {
      if (e.pointerType === 'touch') return;
      self.reach = 1;
      self.point(e.clientX, e.clientY, 'pointer');
    };
    this.onLeave = function (e) {
      if (e.pointerType === 'touch') return;
      self.release(false);
    };
    this.onTouchStart = function (e) {
      var t = e.touches && e.touches[0];
      if (!t) return;
      self.touching = true;
      self.touchAt = performance.now();
      self.touch0 = { x: t.clientX, y: t.clientY };
      self.touchMoved = 0;
      self.reach = self.phone() ? 1.9 : 1.3;
      self.geomAt = 0;
      self.point(t.clientX, t.clientY, 'touch');
    };
    this.onTouchMove = function (e) {
      var t = e.touches && e.touches[0];
      if (!t) return;
      if (self.touch0) self.touchMoved = Math.max(self.touchMoved, Math.abs(t.clientX - self.touch0.x) + Math.abs(t.clientY - self.touch0.y));
      self.point(t.clientX, t.clientY, 'touch');
    };
    this.onTouchEnd = function () {
      var tap = self.touch0 && self.touchMoved < 12 && performance.now() - self.touchAt < 350;
      self.touching = false;
      self.touch0 = null;
      if (tap) self.burst();
      else self.holdUntil = performance.now() + 220;
      self.nextGhost = performance.now() + 9000;
    };
    hero.addEventListener('pointermove', this.onMove, { passive: true });
    hero.addEventListener('pointerleave', this.onLeave, { passive: true });
    this.media.addEventListener('touchstart', this.onTouchStart, { passive: true });
    this.media.addEventListener('touchmove', this.onTouchMove, { passive: true });
    this.media.addEventListener('touchend', this.onTouchEnd, { passive: true });
    this.media.addEventListener('touchcancel', this.onTouchEnd, { passive: true });

    if ('IntersectionObserver' in w) {
      this.io = new IntersectionObserver(function (entries) {
        self.visible = entries[0].isIntersecting;
        if (self.visible) {
          self.geomAt = 0;
          self.wake();
          if (!self.introDone) self.intro();
        }
      }, { threshold: .15 });
      this.io.observe(this.media);
    } else {
      this.visible = true;
      this.wake();
    }
    this.onVis = function () { if (!d.hidden) self.wake(); };
    d.addEventListener('visibilitychange', this.onVis);

    SENSE.engines.push(this);
    bindTilt();
  };

  Engine.prototype.destroy = function () {
    this.dead = true;
    var hero = this.hero;
    hero.removeEventListener('pointermove', this.onMove);
    hero.removeEventListener('pointerleave', this.onLeave);
    this.media.removeEventListener('touchstart', this.onTouchStart);
    this.media.removeEventListener('touchmove', this.onTouchMove);
    this.media.removeEventListener('touchend', this.onTouchEnd);
    this.media.removeEventListener('touchcancel', this.onTouchEnd);
    d.removeEventListener('visibilitychange', this.onVis);
    if (this.io) this.io.disconnect();
    var i = SENSE.engines.indexOf(this);
    if (i > -1) SENSE.engines.splice(i, 1);
  };

  // A single pass of an invisible pointer across the piece, so shoppers can see
  // the banner is alive before they touch it. On phones it comes round again
  // every few seconds while the banner is on screen.
  Engine.prototype.intro = function () {
    this.introDone = true;
    if (this.P) return;
    this.ghost = { start: performance.now() + 500, dur: 2200 };
    this.nextGhost = performance.now() + 9000;
    this.wake();
  };

  // A tap on a phone: one clear moment rather than a hover.
  Engine.prototype.burst = function () {
    var P = this.P;
    if (!P) return;
    var now = performance.now();
    this.want = 1;
    this.holdUntil = now + 450;
    this.decay = 1.1;
    for (var i = 0; i < this.parts.length; i++) {
      var p = this.parts[i], k = p.k, m = p.inv;
      var qx = m.a * P.x + m.c * P.y + m.e, qy = m.b * P.x + m.d * P.y + m.f;
      var dist = Math.sqrt((qx - p.x) * (qx - p.x) + (qy - p.y) * (qy - p.y));
      var near = fall(dist / (p.r * 2.6));
      if (k.sway) p.va += (qx > p.x ? -1 : 1) * (18 + 26 * near);
      if (k.flutter) p.va += p.side * (12 + 20 * near);
      if (k.spin) p.omega += 140 + 160 * near;
      if (k.pop && near > 0) { p.vs += 2.2 * near + .6; p.vdy -= 90 * near; }
      if (k.tilt) p.a += (qx > p.x ? 2 : -2);
      if (k.twinkle && near > 0) p.vs += 3 * near;
    }
    // a ring of sparkles bursting outward from the touch
    var n = SENSE.lite ? 7 : 10;
    for (var j = 0; j < n; j++) {
      var ang = (j / n) * Math.PI * 2 + Math.random() * .4;
      var sp = 150 + Math.random() * 120;
      this.spark(now, P.x + Math.cos(ang) * 14, P.y + Math.sin(ang) * 14, Math.cos(ang) * sp, Math.sin(ang) * sp - 60, 7 + Math.random() * 9, 800 + Math.random() * 400);
    }
    this.wake();
  };

  Engine.prototype.wake = function () {
    if (this.running || this.dead) return;
    if (!this.visible || d.hidden) return;
    this.running = true;
    SENSE.active.push(this);
    SENSE.loop();
  };

  // What moves the pointer on a phone when no finger is on the drawing.
  Engine.prototype.sense = function (now, dt) {
    if (this.touching) return;
    // after a finger lifts (or a tap's moment), the pieces settle slowly
    if (this.driver === 'touch') { if (now >= this.holdUntil) this.release(true); return; }
    if (!this.phone()) return;
    var g = this.geom();
    if (!g) return;
    var rect = g.rect;
    var vh = w.innerHeight || 1;

    // 1. scrolling: the pointer crosses the drawing as it crosses the screen
    if (now - SENSE.scrollAt < 240 && Math.abs(SENSE.scrollV) > 40) {
      var u = clamp((vh - rect.top) / (vh + rect.height), 0, 1);
      var cx = rect.left + rect.width * (.1 + .8 * u);
      var cy = rect.top + rect.height * (.5 + .14 * Math.sin(u * Math.PI * 2));
      this.ghost = null;
      this.point(cx, cy, 'scroll');
      return;
    }
    if (this.driver === 'scroll') { this.release(true); this.nextGhost = now + 7000; return; }

    // 2. tilt (Android): the pieces lean with the phone
    var tl = SENSE.tilt;
    if (tl && now - tl.at < 600 && Math.abs(tl.x) + Math.abs(tl.y) > .1 && !this.ghost) {
      this.point(rect.left + rect.width * (.5 + .42 * tl.x), rect.top + rect.height * (.5 + .3 * tl.y), 'tilt');
      this.want = .8;
      return;
    }
    if (this.driver === 'tilt') { this.release(true); return; }

    // 3. nothing else: a quiet sweep every few seconds
    if (!this.ghost && this.introDone && now > this.nextGhost && this.A < .05) {
      this.ghost = { start: now, dur: 2600 };
      this.nextGhost = now + 8000 + Math.random() * 3000;
    }
  };

  Engine.prototype.frame = function (now, dt) {
    var t = (now - this.t0) / 1000;

    this.sense(now, dt);

    // ghost pointer for the sweeps
    if (this.ghost) {
      var g = this.ghost;
      var u = (now - g.start) / g.dur;
      if (u >= 0 && u <= 1) {
        var e = u < .5 ? 2 * u * u : 1 - Math.pow(-2 * u + 2, 2) / 2;
        var sw = this.sweep;
        var gx = sw[0] + sw[1] * e;
        var gy = sw[2] + sw[3] * Math.sin(u * Math.PI * 1.4);
        var np = { x: gx, y: gy };
        if (this.P) {
          this.V.x = (np.x - this.P.x) / Math.max(dt, 1 / 120);
          this.V.y = (np.y - this.P.y) / Math.max(dt, 1 / 120);
        }
        this.P = np;
        this.want = Math.sin(u * Math.PI) > .08 ? 1 : 0;
        this.lastMove = now;
        this.driver = 'ghost';
        this.reach = this.phone() ? 1.5 : 1;
      } else if (u > 1) {
        this.ghost = null;
        this.want = 0;
        this.driver = '';
        this.decay = this.phone() ? 1.4 : 3;
      }
    }

    // pointer presence eases in fast and out slowly
    this.A += (this.want - this.A) * (this.want > this.A ? 1 - Math.exp(-dt * 14) : 1 - Math.exp(-dt * this.decay));
    // velocity dies away when the pointer rests
    if (now - this.lastMove > 60) {
      this.V.x *= Math.exp(-dt * 10);
      this.V.y *= Math.exp(-dt * 10);
    }

    var P = this.P, V = this.V, A = this.A;
    for (var i = 0; i < this.parts.length; i++) this.step(this.parts[i], P, V, A, t, dt);
    this.sparkle(now, dt);
  };

  Engine.prototype.step = function (p, P, V, A, t, dt) {
    var k = p.k;
    var f = 0, q = null, lvx = 0, lvy = 0, dist = 1e9;
    if (P && A > .001) {
      var m = p.inv;
      q = { x: m.a * P.x + m.c * P.y + m.e, y: m.b * P.x + m.d * P.y + m.f };
      lvx = m.a * V.x + m.c * V.y;
      lvy = m.b * V.x + m.d * V.y;
      dist = Math.sqrt((q.x - p.x) * (q.x - p.x) + (q.y - p.y) * (q.y - p.y));
      f = A * fall(dist / (p.r * this.reach));
    }
    var ts = 1, tdx = 0, tdy = 0, ta = 0;
    var spring = 150, damp = 15;
    var phone = this.phone();

    if (k.pop) {
      ts += p.pop * f;
      if (q) {
        tdx += (q.x - p.x) * .1 * f;
        tdy += (q.y - p.y) * .1 * f - 8 * f;
      }
    }
    // on a phone that is struggling, the idle breathing eases off so the
    // drawing only repaints when something is actually happening
    var lite = SENSE.lite;
    if (k.drift) {
      var am = (p.amp || 6) * (phone ? (lite ? .7 : 1.4) : 1);
      tdx += am * Math.sin(t * .55 + p.ph);
      tdy += am * 1.3 * Math.cos(t * .7 + p.ph * 1.7);
      ta += 2.5 * Math.sin(t * .4 + p.ph);
    }
    if (k.twinkle) {
      ts = (lite ? .96 : .82 + .28 * (.5 + .5 * Math.sin(t * 2.1 + p.ph))) + .9 * f;
      ta = 45 * f;
    }
    if (k.tilt) {
      var at = p.amp || 1.5;
      var tf = A;
      if (P) {
        var qq = q || { x: p.inv.a * P.x + p.inv.c * P.y + p.inv.e, y: p.inv.b * P.x + p.inv.d * P.y + p.inv.f };
        tdx += clamp((qq.x - p.x) * .035, -16, 16) * tf;
        tdy += clamp((qq.y - p.y) * .025, -10, 10) * tf;
        ta += clamp((qq.x - p.x) * .006, -at, at) * tf;
      }
      ta += .5 * Math.sin(t * .6 + p.ph);
      tdy += 3 * Math.sin(t * .8 + p.ph);
      spring = 50; damp = 11;
    }

    // scale and offset follow their targets on a slightly bouncy spring
    p.vs += (ts - p.s) * spring * dt; p.vs *= Math.exp(-damp * dt); p.s += p.vs * dt;
    p.vdx += (tdx - p.dx) * spring * dt; p.vdx *= Math.exp(-damp * dt); p.dx += p.vdx * dt;
    p.vdy += (tdy - p.dy) * spring * dt; p.vdy *= Math.exp(-damp * dt); p.dy += p.vdy * dt;

    var ang = 0;
    if (k.sway || k.flutter) {
      // a pendulum: a restoring pull, damping, and a push from the pointer's movement
      var sw = k.sway;
      var idle = (p.amp || (sw ? 1.5 : 2)) * (phone ? (lite ? .8 : 1.3) : 1) * Math.sin(t * (sw ? 1.25 : 1.7) + p.ph);
      var target = idle + (k.flutter ? p.side * 9 * f : 0);
      var K = sw ? 16 : 40, C = sw ? 2.4 : 6;
      var push = (sw ? .012 : .006) * f * (lvx - (k.flutter ? lvy * .4 : 0));
      p.va += ((target - p.a) * K + push * 60) * dt;
      p.va *= Math.exp(-C * dt);
      p.a = clamp(p.a + p.va * dt, -28, 28);
      ang = p.a;
    } else if (k.spin) {
      var tang = 0;
      if (q && dist > 20) {
        var rx = q.x - p.x, ry = q.y - p.y;
        tang = (rx * lvy - ry * lvx) / (dist * dist) * 57.3;
      }
      p.omega += (tang * .04 * f) ;
      p.omega *= Math.exp(-1.6 * dt);
      p.spin += (p.speed + p.omega) * dt;
      ang = p.spin;
    } else {
      p.a += ((ta) - p.a) * (1 - Math.exp(-dt * (k.tilt ? 5 : 12)));
      ang = p.a;
    }

    // on a phone the numbers are rounded more coarsely: a change the eye cannot
    // see is not worth a repaint
    var q1 = phone ? r1 : r3;
    var tr = '';
    var moved = Math.abs(p.s - 1) > .003 || Math.abs(p.dx) > .08 || Math.abs(p.dy) > .08 || Math.abs(ang) > .04;
    if (moved) {
      var pvx = (k.sway || k.flutter) ? p.px : p.x;
      var pvy = (k.sway || k.flutter) ? p.py : p.y;
      tr = 'translate(' + q1(p.dx) + ' ' + q1(p.dy) + ')';
      if (Math.abs(ang) > .04) tr += ' rotate(' + q1(ang) + ' ' + r1(pvx) + ' ' + r1(pvy) + ')';
      if (Math.abs(p.s - 1) > .003) tr += ' translate(' + r1(p.x) + ' ' + r1(p.y) + ') scale(' + (phone ? r2(p.s) : r3(p.s)) + ') translate(' + r1(-p.x) + ' ' + r1(-p.y) + ')';
    }
    if (tr !== p.last) {
      if (tr) p.el.setAttribute('transform', tr);
      else p.el.removeAttribute('transform');
      p.last = tr;
    }
  };

  // Sparkles come from a small pool of elements that are reused, instead of
  // being created and thrown away: that churn was most of the jank on phones.
  Engine.prototype.spark = function (now, x, y, vx, vy, r, life) {
    var cap = this.phone() ? (SENSE.lite ? 10 : 14) : 26;
    if (this.sparks.length >= cap) return;
    if (this.phone()) r *= 1.15; // a touch larger than on desktop, no more
    var el = this.pool.pop();
    if (!el) {
      el = d.createElementNS(NS, 'path');
      el.setAttribute('pointer-events', 'none');
    }
    var kk = r * .18;
    el.setAttribute('d', 'M0 ' + (-r) + 'Q' + kk + ' ' + (-kk) + ' ' + r + ' 0Q' + kk + ' ' + kk + ' 0 ' + r + 'Q' + (-kk) + ' ' + kk + ' ' + (-r) + ' 0Q' + (-kk) + ' ' + (-kk) + ' 0 ' + (-r) + 'Z');
    el.setAttribute('fill', this.colors[Math.floor(Math.random() * this.colors.length)]);
    el.setAttribute('transform', 'translate(' + r1(x) + ' ' + r1(y) + ') scale(0)');
    if (!el.parentNode) this.root.appendChild(el);
    this.sparks.push({ el: el, x: x, y: y, vx: vx || 0, vy: vy || 0, born: now, life: life, rot: Math.random() * 90 });
  };

  Engine.prototype.sparkle = function (now, dt) {
    var P = this.P;
    var speed = Math.sqrt(this.V.x * this.V.x + this.V.y * this.V.y);
    var every = this.phone() ? (SENSE.lite ? 110 : 80) : 55;
    if (P && this.A > .3 && speed > 90 && now - this.lastSpark > every) {
      this.lastSpark = now;
      var finger = this.driver === 'touch';
      // under a finger the sparkles rise above and beside it, where they can be seen
      var sx = P.x + (Math.random() - .5) * (finger ? 110 : 30);
      var sy = P.y + (finger ? -34 - Math.random() * 56 : (Math.random() - .5) * 30);
      this.spark(now, sx, sy, finger ? (Math.random() - .5) * 60 : 0, finger ? -30 : 0, 7 + Math.random() * 12, 700 + Math.random() * 400);
    }
    for (var i = this.sparks.length - 1; i >= 0; i--) {
      var s = this.sparks[i];
      var u = (now - s.born) / s.life;
      if (u >= 1) {
        s.el.setAttribute('transform', 'scale(0)');
        this.pool.push(s.el);
        this.sparks.splice(i, 1);
        continue;
      }
      if (s.vx || s.vy) {
        s.x += s.vx * dt; s.y += s.vy * dt;
        s.vx *= Math.exp(-2.2 * dt); s.vy *= Math.exp(-2.2 * dt);
      }
      var sc = Math.sin(u * Math.PI);
      s.el.setAttribute('transform', 'translate(' + r1(s.x) + ' ' + r1(s.y - 26 * u) + ') rotate(' + r1(s.rot + 60 * u) + ') scale(' + r2(sc) + ')');
      s.el.setAttribute('fill-opacity', r2(.85 * (1 - u * .4)));
    }
  };

  /* ------------------------------------------------------------- stand --- */

  function Stand(el) {
    this.el = el;
    this.items = Array.prototype.slice.call(el.querySelectorAll('.jsq-stand__item'));
    this.engines = [];
    this.visible = false;
    this.ghost = null;
    this.introDone = false;
    this.counts();
    if (!RM.matches) this.motion();
  }

  // Each drawing gets its own engine; its link is the hover and touch surface.
  // On wide screens the stand plays one sweep across all four drawings, so
  // the engines' own intro is skipped; on phones each drawing sweeps itself.
  Stand.prototype.motion = function () {
    var self = this;
    this.items.forEach(function (item) {
      var svg = item.querySelector('svg');
      var root = svg && svg.querySelector('[data-jx-root]');
      if (!root || !root.getCTM()) { self.engines.push(null); return; }
      var en = new Engine(svg, item, item);
      if (WIDE.matches) en.introDone = true;
      self.engines.push(en);
    });

    if ('IntersectionObserver' in w) {
      this.io = new IntersectionObserver(function (entries) {
        self.visible = entries[0].isIntersecting;
        if (self.visible && !self.introDone && entries[0].intersectionRatio >= .35) self.intro();
      }, { threshold: [0, .35] });
      this.io.observe(this.el.querySelector('.jsq-stand__row') || this.el);
    }
  };

  // one invisible pass across the whole stand, so shoppers can see it is alive
  Stand.prototype.intro = function () {
    this.introDone = true;
    if (!WIDE.matches) return;
    for (var i = 0; i < this.engines.length; i++) if (this.engines[i] && this.engines[i].driver) return;
    this.ghost = { start: performance.now() + 450, dur: 2600, cur: -1 };
    var self = this;
    requestAnimationFrame(function tick(now) {
      if (!self.ghost || self.dead) return;
      self.drive(now);
      if (self.ghost) requestAnimationFrame(tick);
    });
  };

  Stand.prototype.drive = function (now) {
    var g = this.ghost;
    var u = (now - g.start) / g.dur;
    if (u < 0) return;
    var svgs = this.items.map(function (it) { return it.querySelector('svg'); });
    if (u > 1 || !svgs[0] || !svgs[svgs.length - 1]) {
      if (g.cur > -1 && this.engines[g.cur]) this.engines[g.cur].release(false);
      this.ghost = null;
      return;
    }
    var a = svgs[0].getBoundingClientRect(), b = svgs[svgs.length - 1].getBoundingClientRect();
    var e = u < .5 ? 2 * u * u : 1 - Math.pow(-2 * u + 2, 2) / 2;
    var x = a.left - 40 + (b.right - a.left + 80) * e;
    var y = a.top + a.height * (.42 + .16 * Math.sin(u * Math.PI * 2.2));
    var idx = -1;
    for (var i = 0; i < svgs.length; i++) {
      var r = svgs[i].getBoundingClientRect();
      if (x >= r.left && x < r.right) { idx = i; break; }
    }
    if (idx !== g.cur && g.cur > -1 && this.engines[g.cur]) this.engines[g.cur].release(false);
    g.cur = idx;
    if (idx > -1 && this.engines[idx]) this.engines[idx].point(x, y, 'ghost');
  };

  Stand.prototype.destroy = function () {
    this.dead = true;
    this.ghost = null;
    this.engines.forEach(function (en) { if (en) en.destroy(); });
    if (this.io) this.io.disconnect();
  };

  /* ------------------------------------------------------------ counts --- */

  var CACHE = 'jsq-stand-counts';
  var store = function () {
    try { return JSON.parse(w.sessionStorage.getItem(CACHE) || '{}'); } catch (e) { return {}; }
  };
  var save = function (o) {
    try { w.sessionStorage.setItem(CACHE, JSON.stringify(o)); } catch (e) { /* private mode */ }
  };

  Stand.prototype.counts = function () {
    if (this.el.getAttribute('data-counts') === 'false' || !w.fetch) return;
    var items = this.items;
    var go = function () {
      var cache = store();
      var fresh = Date.now() - 10 * 60 * 1000;
      items.forEach(function (item) {
        var slot = item.querySelector('[data-jsq-count]');
        if (!slot) return;
        var url;
        try { url = new URL(item.getAttribute('href'), w.location.href); } catch (e) { return; }
        if (url.origin !== w.location.origin || url.pathname.indexOf('/collections/') === -1) return;
        var key = url.pathname + url.search;
        var put = function (n) { slot.textContent = n === 1 ? '1 piece' : n + ' pieces'; };
        if (cache[key] && cache[key].at > fresh) { put(cache[key].n); return; }
        url.searchParams.set('section_id', 'jsq-count');
        fetch(url.toString(), { credentials: 'same-origin' })
          .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
          .then(function (html) {
            var m = html.match(/data-jsq-count="(\d+)"/);
            if (!m) return;
            var n = parseInt(m[1], 10);
            if (!(n > 0)) return;
            put(n);
            var c = store();
            c[key] = { n: n, at: Date.now() };
            save(c);
          })
          .catch(function () { /* keep the plain link text */ });
      });
    };
    if ('requestIdleCallback' in w) w.requestIdleCallback(go, { timeout: 1200 });
    else setTimeout(go, 300);
  };

  /* -------------------------------------------------------------- setup --- */

  function boot(scope) {
    var list = (scope || d).querySelectorAll('[data-jsq-stand]');
    for (var i = 0; i < list.length; i++) {
      if (list[i].__jsqStand) continue;
      list[i].__jsqStand = new Stand(list[i]);
    }
  }

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();

  d.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  d.addEventListener('shopify:section:unload', function (e) {
    var el = e.target.querySelector('[data-jsq-stand]');
    if (el && el.__jsqStand) { el.__jsqStand.destroy(); el.__jsqStand = null; }
  });
})();
